import { ref } from 'vue';
type IconMap = Record<string, string>;

const icons = ref<IconMap | null>(null);

export const useIcons = () => {
    const getAllIcons = (): IconMap => {
        return import.meta.glob('~/assets/icons/**/*.svg', {
            query: '?raw',
            import: 'default',
            eager: true,
        }) as IconMap;
    };

    const findIcon = (name: string): string | null => {
        if (!icons.value) {
            icons.value = getAllIcons();
        }

        const iconPath = Object.keys(icons.value).find((path) => path.endsWith(`/${name}.svg`));

        return iconPath ? (icons.value[iconPath] ?? null) : null;
    };

    return {
        findIcon,
    };
};
